/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable camelcase */
import React from 'react';
import { object, string } from 'yup';
import axios from 'axios';
import { useState } from 'react';
import { Form, FormField, TextField, Card, CardBody, Button } from '@emoney/kyber';

const UserLookupForm = () => {

    const [username, setUsername] = useState('');

    const validationSchema = object().shape({
        username: string().required()
    });

    const handleSubmit = (values, actions) => {
        actions.setSubmitting(false);
        // eslint-disable-next-line no-restricted-globals
        axios.get(location.protocol + '//' + location.host + '/emxredirect', { params: { username: values.username } }).then(result => {
            window.location.replace(result.data + window.location.pathname.replace(/^(\/emx\/)/, "/") + window.location.search);
        });
    };

    const usernameChange = (event, payload) => {
        setUsername(payload.value);
    };

    const renderCustomFooter = (props) => {
        return (
            <div>
                <div className="UserLookupFormButtonContainer">
                    <Button className="btn-primary NextButton" id="submit-button" type="submit">
                        Next
                    </Button>
                </div>
            </div>
        );
    };

    return (
        <Card className="section-content" id="UserLookupFormCard">
			<CardBody className="CardBody">
                <Form
                    id="UserLookupForm"
                    onSubmit={handleSubmit}
                    footerRenderer={renderCustomFooter}
                    validationSchema={validationSchema}
                >
                    <FormField id="UserLookupFormField" className="username-label"  label="Username">
                        <TextField
                            id="username-input"
                            name="username"
                            value={username}
                            onChange={usernameChange}
                        />
                    </FormField>
                </Form>
			</CardBody>
		</Card>
    );
};

export default UserLookupForm;